<template>
	<div class="main">
		<topback title="Promotion and Revenue" path="/my"></topback>

		<md-field class="userinfo">
			<md-cell-item :title="this.$store.state.userinfo.name">
				<div class="userinfo-ratio" slot="default">
					<span>{{ 'Reward ratio:' + this.$store.state.userinfo.payee_reward_ratio }}</span>
					<span>{{ 'Enjoy dividends:' + (this.$store.state.userinfo.is_dividend ? 'yes': 'no') }}</span>
				</div>
				<span slot="right" @click="gorouter('accountinfo')">ID: {{this.$store.state.userinfo.collectionworkerid}}</span>
				<span class="avatar" slot="left"><img src="/static/images/avatar.png" alt=""/></span>
			</md-cell-item>
		</md-field>

		<md-tab-bar class="md-bar" v-model="current" :items="items" :has-ink="false" @change="choose_btn">
			<template slot="item" slot-scope="{ item }">
			<div class="custom-item" style="margin: 0.1rem 0rem !important">
				<div class="icon">
				<iconimg :name="item.icon" size="xl"></iconimg>
				</div>
				<div class="text">
				<span v-text="item.label"></span>
				</div>
			</div>
			</template>
		</md-tab-bar>

		<card color="#f3f3f6">
			<div slot="card-body">
				<md-cell-item title="My Commission"></md-cell-item>
				<div class="btngroup">
					<div class="btnitem">
						<iconimg name="yesterday" class="holder"></iconimg>
						<span class="title">Yesterday</span>
						<span class="title">{{ teaminfos.yesterday_commission }}</span>
					</div>
					<div class="btnitem">
						<iconimg name="today" class="holder"></iconimg>
						<span class="title">Today</span>
						<span class="title">{{ teaminfos.today_commission }}</span>
					</div>
					<div class="btnitem">
						<iconimg name="profit" class="holder"></iconimg>
						<span class="title">Total</span>
						<span class="title">{{ teaminfos.total_commission }}</span>
					</div>
				</div>
				
			</div>
		</card>
		
		<card color="#f3f3f6" v-if="this.$store.state.userinfo.is_dividend">
			<div slot="card-body">
				<md-cell-item title="My Dividend"></md-cell-item>
				<div class="btngroup" v-if="this.$store.state.userinfo.is_dividend">
					<div class="btnitem">
						<iconimg name="yesterday" class="holder"></iconimg>
						<span class="title">Yesterday</span>
						<span class="title">{{ teaminfos.team_yesterday_dividend }}</span>
					</div>
					<div class="btnitem">
						<iconimg name="today" class="holder"></iconimg>
						<span class="title">Today</span>
						<span class="title">{{ teaminfos.team_today_dividend }}</span>
					</div>
					<div class="btnitem">
						<iconimg name="profit" class="holder"></iconimg>
						<span class="title">Total</span>
						<span class="title">{{ teaminfos.team_total_dividend }}</span>
					</div>
				</div>
				<div class="promote-text" v-else>
					<p>Promote more users and contact <a @click="gorouter('customerservice')">customer service</a> to apply for additional dividends</p>
				</div>
			</div>
		</card>

		<card color="#f3f3f6">
			<div slot="card-body">
				<md-cell-item title="Team Infos"></md-cell-item>
				<div class="btngroup">
					<div class="btnitem">
						<iconimg name="kyc" class="holder"></iconimg>
						<span class="title">New ct today</span>
						<span class="title">{{ teaminfos.today_new_ct_count }}</span>
					</div>
					<div class="btnitem">
						<iconimg name="today" class="holder"></iconimg>
						<span class="title">Register today</span>
						<span class="title">{{ teaminfos.today_new_cw_count }}</span>
					</div>
					<div class="btnitem">
						<iconimg name="team" class="holder"></iconimg>
						<span class="title">Team count</span>
						<span class="title">{{ teaminfos.team_count }}</span>
					</div>
				</div>
				<div class="btngroup">
					<div class="btnitem">
						<iconimg name="today" class="holder"></iconimg>
						<span class="title">Today Buy Itoken</span>
						<span class="title">{{ teaminfos.team_today_recharge }}</span>
					</div>
					<div class="btnitem">
						<iconimg name="profit" class="holder"></iconimg>
						<span class="title">Total Buy Itoken</span>
						<span class="title">{{ teaminfos.team_total_recharge }}</span>
					</div>
				</div>
				
			</div>
		</card>
	</div>
</template>


<script>
import topback from "@/components/topback";
import { TabBar, Field, CellItem } from "mand-mobile";
import { teaminfoport,getmyteam } from '@/request/api'
import iconimg from '@/components/iconimg'

export default {
	name: "AcountInfo",
	components: {
		[topback.name]: topback,
		[Field.name]: Field,
		[CellItem.name]: CellItem,
		iconimg,
		TabBar
	},

	data() {
		return {
			teaminfos: {},
			teaminfo: {},
            page: 1,
            limit: 10,
            parent: "",
            isFinished: false,
            nodata: true,
            children: [],
			current: 0,
			items: [
				{name: 0, label: 'My Team', icon: 'team'},
				{name: 1, label: 'Commission', icon: 'commission'},
				{name: 2, label: 'Dividend', icon: 'dividend'},
				{name: 3, label: 'Invite link', icon: 'share_link'}
			],
		};
	},
	mounted() {
		this.getmyteaminfo();
	},
	methods: {
		getmyteaminfo() {
			this.$toast.loading("Loading..")
			teaminfoport({}).then(res => {
				let that = this;
				that.$toast.hide();
				if (res.code === 200) {
					this.teaminfos = res.data;
				} else {
					that.$toast.failed(res.errmsg);
				}
			});
		},
		choose_btn(item, index, prevIndex){
			switch(index) {
				case 0:
					this.go_myteam();
					break;
				case 1:
					this.go_itoken_history('commission');
					break;
				case 2:
					this.go_itoken_history('dividend');
					break;
				case 3:
					this.go_invitelinkmanage();
					break;
				default:
					break;
			}
		},
		go_itoken_history(purpose) {
			this.$router.push("/my/itokenhistory/" + purpose);
		},
		go_myteam() {
			this.$router.push("/myteam");
		},
		go_invitelinkmanage() {
            this.$router.push("/invitelinkmanage");
        },
		gorouter(name) {
			this.$router.push({"name": name});
		}
	}
};
</script>
<style scoped>
.userinfo-ratio span {
	display: flex;
    flex-direction: column;
	font-size: 0.28rem;
	color: #858b9c;
}
.userinfo {
  padding-bottom: 0;
  margin-top: 0.7rem;
}

.menu {
  padding-top: 10px
}

.avatar {
  display: block;
  width: 88px;
  height: 88px;
  border-radius: 44px;
  background-color: #E6E6E6;
}

.avatar img {
  display: block;
  width: 88px;
  height: 88px;
  border-radius: 44px;
  background-color: #E6E6E6;
}

.holder {
  line-height: 0px;
  font-size: 39px;
}

.signoutbtn {
  background-color: #aaa;
}

.userinfo >>> .md-cell-item-brief {
  width: 3rem;
  overflow: hidden;
}
.btngroup .holder {
    margin: 10px auto;
    display: block;
    width: 80px;
    height: 80px;
    border-radius: 50%;
}

.holder {
    line-height: 0px;
    font-size: 39px;
}

.btnitem .title {
    font-size: 0.26rem;
    margin: 0.05rem;
}

.btngroup {
    margin: 0.2rem 0;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}

.btngroup .btnitem {
    text-align: center;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    width: calc(90% / 3);
    height: calc(90% / 3);
    border-radius: 20px;
    box-shadow: 0 8px 12px #ebedf0;
    overflow: auto;
}
.md-bar{
  margin: 0.3rem 0;
  padding-left: 0rem !important;
  padding-right: 0rem !important;
}
.custom-item {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}
.promote-text {
	font-size: 0.3rem;
}

.promote-text a {
	font-weight: bold;
	color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/my/agent.vue